export default "__VITE_ASSET__549f9c09__"